import { KeyValue } from "@/main/models/common";
import { Result } from "@models/common/resultResponse";
import { AxiosResponse } from "axios";
import { api } from "./base/api";

const baseRoute: string = "IntegrationPropertyFilter";

export class IntegrationPropertyFilterApi {
	getDomain(idIntegrationInteface: string): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/GetPropertiesByIntegrationInterface`, {
			params: { idIntegrationInteface },
		});
	}
}
